export default __webpack_public_path__ + "static/media/finalRM2.69d3ae73.png";